import React, { useState } from "react";
import { Navigate, Outlet, useNavigate, useLocation } from "react-router-dom";
import { getAccesstoken } from "../utils/auth";
import Footer from "../components/Shared/Footer";
import Portfolibackground from "../UserAssets/cover-img.jpg"
import { getUserFullName, getUserEmail, getProfileImage } from "../utils/auth";

const UserDashboard = () => {
  const [activeBlend, setActiveBlend] = useState("Dashboard");
  const [isMenuVisible, setIsMenuVisible] = useState(false);
const fullName = getUserFullName();
const email = getUserEmail();
  const navigate = useNavigate();
  const token = getAccesstoken();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  const blends = [
    // { name: "Dashboard", icon: "fa-solid fa-chart-line", route: "/user/dashboard" },
    { name: "Profile", icon: "fa-solid fa-user", route: "/user/profile" },
    { name: "Orders", icon: "fa-solid fa-box", route: "/user/orders" },
    { name: "Assessments", icon: "fa-solid fa-file-alt", route: "/user/assessments" },
    { name: "Appointment Booking", icon: "fa-solid fa-calendar-check", route: "/user/consultations" },
    // { name: "Appointment Bookings", icon: "fa-solid fa-calendar-check", route: "/user/appointments" },
  ];

  return (
    <div>
      {/* Breadcrumb Section */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>User Dashboard</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">User Dashboard</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Section */}
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row">
            {/* Left Column */}
            <div className="col-xl-4 mb-3">
              {/* Mobile Menu Toggle Button */}
              <button
                className="btn btn-primary d-xl-none mb-3"
                onClick={() => setIsMenuVisible(!isMenuVisible)}
              >
                {isMenuVisible ? "Hide Menu" : (
                  <div className="d-flex gap-2 align-items-center">
                    <i className="fas fa-bars"></i> Show Menu
                  </div>
                )}
              </button>

              {/* Sidebar Menu */}
              <div
                className={`menu-container ${
                  isMenuVisible || window.innerWidth >= 1200
                    ? "show-menu"
                    : "hide-menu"
                }`}
              >
                {/* Profile Card */}
                <div className="card user_card mb-4 text-center">
                  <div className="cover-img-container">
                    <img
                      src={Portfolibackground}
                      alt="User Avatar"
                      className="cover-img"
                    />
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <img
                      src={`https://mycarb-reducarb.com/${getProfileImage()}`} 
                      alt=""
                      className="profile-img rounded-circle"
                    />
                    {/* <i
                      className="fa-solid fa-pencil edit-icon"
                      title="Edit Profile Picture"
                    ></i> */}
                  </div>
                  <div className="card-body">
                    <div className="font-md text-center fw-semibold">
                      {fullName}
                    </div>
                    <p className="card-text text-muted">{email}</p>
                  </div>
                </div>

                {/* Navigation */}
                <div>
                  {blends.map((blend, index) => (
                    <div
                      key={index}
                      className={`mb-2 font-md blend-item ${
                        activeBlend === blend.name
                          ? "active_background_white fw-semibold"
                          : "grey_non_active fw-semibold"
                      }`}
                      onClick={() => {
                        setActiveBlend(blend.name);
                        setIsMenuVisible(false); // Auto-hide menu after selection
                        navigate(blend.route);
                      }}
                    >
                      <i
                        className={`${blend.icon} me-4`}
                        style={{ color: "var(--theme-color)" }}
                      ></i>
                      {blend.name}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-xl-8">
              <Outlet />
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <style jsx>{`
        .menu-container {
          position: fixed;
          top: 0;
          left: 0;
          height: 100%;
          width: 80%;
          background: #fff; /* White background for mobile */
          box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
          overflow-y: auto;
          z-index: 1000;
          transform: translateX(-100%);
          transition: transform 0.3s ease-in-out;
        }

        .menu-container.show-menu {
          transform: translateX(0);
        }

        .menu-container.hide-menu {
          transform: translateX(-100%);
        }

        .blend-itemss {
          padding: 15px 20px;
          text-align: left;
        }

        .user_card {
          margin-bottom: 1rem;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 10px;
        }

        .cover-img-container {
          margin-bottom: 1rem;
        }

        .profile-img {
          width: 80px;
          height: 80px;
        }

        @media (min-width: 1200px) {
          .menu-container {
            position: relative;
            transform: translateX(0);
            width: auto;
            background: none; /* Remove white background for larger screens */
            box-shadow: none; /* Remove box-shadow for larger screens */
          }
        }
      `}</style>
    </div>
  );
};

export default UserDashboard;
